import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * Attaches credentials and X-App-Portal header to every outgoing API request.
 * The X-App-Portal custom header acts as CSRF protection: browsers trigger a CORS
 * preflight for any cross-origin request that carries a non-standard header,
 * and our CORS policy only allows our known Angular app origins.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiUrl)) {
    const cloned = req.clone({
      withCredentials: true,
      setHeaders: { 'X-App-Portal': 'Admin' }
    });
    return next(cloned);
  }

  return next(req);
};
